import React from 'react';
import classes from './analytics.module.scss';
import PipelineProgress from './ChartComtonents/PipelineProgress';
import ActivitiesCompleted from './ChartComtonents/ActivitiesCompleted';
import TotalContactsImports from './ChartComtonents/TotalContactsImports';
import Contacted from './ChartComtonents/Contacted';
import FollowUp from './ChartComtonents/FollowUp';

function Analytics() {
  return (
    <div className={classes.persons_analytics_wrapper}>
      <div className={classes.persons_analytics_header_wrapper}>
        <div className={`${classes.persons_analytics_header_item} persons_analytics_header_item`}>
          <TotalContactsImports />
        </div>

        <div className={classes.persons_analytics_header_item}>
          <Contacted />
        </div>

        <div className={classes.persons_analytics_header_item}>
          <FollowUp />
        </div>

      </div>

      <div className={classes.persons_analytics_bottom_wrapper}>
        <div className={classes.persons_analytics_bottom_item}>
          <PipelineProgress />
        </div>

        <div className={classes.persons_analytics_bottom_item}>
          <ActivitiesCompleted />
        </div>
      </div>

    </div>
  );
}

export default Analytics;
